import { replaceArrayItem } from "services/utils";
import {
  listApprovers,
  createApprover,
  updateApprover,
  deleteApprover,
} from "services/apiMiddleware";

const approvers = {
  state: {
    isLoading: false,
    error: null,
    items: [],
  },
  reducers: {
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadSuccess: (state, items) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items,
      };
    },
    createSuccess: (state, newItem) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: [...state.items, newItem],
      };
    },
    updateSuccess: (state, updatedItem) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: replaceArrayItem(state.items, (item) => item.id === updatedItem.id, updatedItem),
      };
    },
    deleteSuccess: (state, deletedId) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: state.items.filter((item) => item.id !== deletedId),
      };
    },
    failure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
      };
    },
  },
  effects: (dispatch) => ({
    async load() {
      try {
        dispatch.approvers.loadStart();
        const { data, errorMessage } = await listApprovers();
        dispatch.approvers.loadSuccess(data);
        if (errorMessage) console.warn(errorMessage);
      } catch (error) {
        dispatch.approvers.failure("loading approvers failed");
      }
    },
    async create(createProps) {
      try {
        dispatch.approvers.loadStart();
        const { data, errorMessage } = await createApprover(createProps);
        if (errorMessage) console.warn(errorMessage);
        dispatch.approvers.createSuccess(data);
        return data;
      } catch (error) {
        dispatch.approvers.failure("creating approver failed");
        throw error;
      }
    },
    async update(updateProps) {
      try {
        dispatch.approvers.loadStart();
        const { data, errorMessage } = await updateApprover(updateProps);
        if (errorMessage) console.warn(errorMessage);
        dispatch.approvers.updateSuccess(data);
        return data;
      } catch (error) {
        dispatch.approvers.failure("updating approver failed");
        throw error;
      }
    },
    async delete(approver) {
      try {
        dispatch.approvers.loadStart();
        const { data, errorMessage } = await deleteApprover(approver.id);
        if (errorMessage) console.warn(errorMessage);
        dispatch.approvers.deleteSuccess(data.id);
      } catch (error) {
        dispatch.approvers.failure("deleting approver failed");
        throw error;
      }
    },
  }),
};

export default approvers;
